import { Configuration, FrontendApi } from "@ory/client";
import appConfig from '../appConfig';
import { debounce } from 'lodash';
import router from "../router";


const ory = new FrontendApi(
  new Configuration({
    basePath: appConfig.oryBasePath,
    baseOptions: {
      withCredentials: true,
    },
  })
);

export class AuthorizeOryService {
  constructor() {
    this._logoutUrl = null;
    this._session = null;
    this.isAuthenticated = debounce(this.isAuthenticated, 500, {
      leading: true
    });
  }

  clearState() {
    this._session = null;
    this._logoutUrl = null;
  }

  validateSession() {
    if (!this._session)
      return false;
    if (!this._session.active)
      return false;
    if (Date.parse(this._session.expires_at) < Date.now())
      return false;
    if (new Date(this._session.tokenClaims.exp * 1000) < Date.now())
      return false;

    return true;
  }

  async isAuthenticated() {
    try {
      if (this._session && this.validateSession()) {
        return true;
      }

      let sessionResponse = await ory.toSession({
        tokenizeAs: appConfig.jwtTemplate
      });
      const logoutFlowResponse = await ory.createBrowserLogoutFlow();
      this._logoutUrl = logoutFlowResponse.data.logout_url;
      this._session = {
        ...sessionResponse.data,
        tokenClaims: this.parseToken(sessionResponse.data.tokenized)
      };
      return true;
    } catch (error) {
      console.error('isAuthenticated', error)
      this.clearState();
      if (appConfig.loginRedirectLocal) {
        router.push(appConfig.loginRedirectLocal)
      } else {
        const flowResponse = await ory.createBrowserLoginFlow({
          returnTo: window.location.origin,
        });
        window.location.href = flowResponse.data.request_url;
      }
      return false;
    }
  }

  async getUser() {
    if (this._session) {
      return this._session.identity;
    }

    await this.isAuthenticated();
    return {
      email: this._session.traits.email,
      given_name: this._session.traits.email,
    };
  }

  async getAccessToken() {
    if (await this.isAuthenticated())
      return this._session.tokenized
  }

  parseToken(token) {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload));
  }

  async signIn() {
    return Promise.resolve();
  }

  hasAnyRole(roles) {
    return this._session?.identity?.metadata_public?.Roles?.some(r => roles.includes(r)) || false;
  }
}

const authService = new AuthorizeOryService();

export default authService;